/* eslint-disable */
// @ts-nocheck
const value: any =
[
    {
        id: 1,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Shiverpeak_Mountains',
    },
    {
        id: 2,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Ascalon',
    },
    {
        id: 3,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Ruins_of_Orr',
    },
    {
        id: 4,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Kryta',
    },
    {
        id: 5,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Maguuma_Jungle',
    },
    {
        id: 8,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Steamspur_Mountains',
    },
    {
        id: 10,
        expansion: 'hot',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Heart_of_Maguuma',
    },
    {
        id: 11,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Maguuma_Wastes',
    },
    {
        id: 12,
        expansion: 'pof',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Crystal_Desert',
    },
    {
        id: 20,
        expansion: 'base',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Ring_of_Fire',
    },
    {
        id: 37,
        expansion: 'eod',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Cantha',
    },
]

export default value;
